import {authHeader} from '../backend'
import {handleResponse} from './handleResponse'

export const csService = {
  postInquire,
  getInquireList,
  getInquireId,
  postInquireReply,
  putInquireReply
}

function postInquire (type, title, content) {
  let requestOptions = {
    method: 'POST',
    headers: authHeader(),
    cache: 'no-cache',
    body: JSON.stringify({type, title, content})
  }
  return fetch(`${process.env.BASE_API}/cs/inquire/my`, requestOptions).then(handleResponse)
}

function getInquireList (pageNo = 1, pageSize, standbyYn, type, clubList, searchValue) {
  let requestOptions = {
    method: 'GET',
    cache: 'no-cache',
    headers: authHeader()
  }
  let queryString = ''
  queryString += `pageNo=${pageNo}`
  if (pageSize) queryString += `&pageSize=${pageSize}`
  if (standbyYn) queryString += `&standbyYn=1`
  if (type) queryString += `&type=${type}`
  if (clubList && clubList.length) queryString += `&clubList=${clubList}`
  if (searchValue) queryString += `&searchValue=${searchValue}`
  return fetch(`${process.env.BASE_API}/cs/inquire/list?${queryString}`, requestOptions).then(handleResponse)
}

function getInquireId (inquireId) {
  let requestOptions = {
    method: 'GET',
    cache: 'no-cache',
    headers: authHeader()
  }
  return fetch(`${process.env.BASE_API}/cs/inquire/${inquireId}`, requestOptions).then(handleResponse)
}

function postInquireReply (inquireId, replyContent) {
  let requestOptions = {
    method: 'POST',
    cache: 'no-cache',
    headers: authHeader(),
    body: JSON.stringify({reply_content: replyContent})
  }
  return fetch(`${process.env.BASE_API}/cs/inquire/reply/${inquireId}`, requestOptions).then(handleResponse)
}

function putInquireReply (inquireId, replyContent) {
  let requestOptions = {
    method: 'PUT',
    cache: 'no-cache',
    headers: authHeader(),
    body: JSON.stringify({reply_content: replyContent})
  }
  return fetch(`${process.env.BASE_API}/cs/inquire/reply/${inquireId}`, requestOptions).then(handleResponse)
}



// WEBPACK FOOTER //
// ./src/router/csRouter.js